var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93691 5.97095C3.87491 7.06095 3.10391 8.43095 2.73291 9.95895",
    stroke: "#3E4145",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28979 20.443C9.88079 20.571 10.4938 20.642 11.1238 20.642C12.0158 20.642 12.8768 20.506 13.6868 20.255",
    stroke: "#3E4145",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73389 14.041C3.10489 15.569 3.87589 16.939 4.93789 18.029",
    stroke: "#3E4145",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4049 14.464C18.9859 15.876 18.2119 17.133 17.1929 18.142",
    stroke: "#3E4145",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1929 5.85791C18.2119 6.86691 18.9849 8.12391 19.4049 9.53591",
    stroke: "#3E4145",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28979 3.55701C9.88079 3.42901 10.4938 3.35801 11.1238 3.35801C12.0158 3.35801 12.8768 3.49401 13.6868 3.74501",
    stroke: "#3E4145",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5336 10.2321C22.5099 11.2084 22.5099 12.7913 21.5336 13.7676C20.5573 14.744 18.9744 14.744 17.9981 13.7676C17.0218 12.7913 17.0218 11.2084 17.9981 10.2321C18.9744 9.2558 20.5573 9.2558 21.5336 10.2321",
    stroke: "#3E4145",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8266 17.5691C9.80291 18.5455 9.80291 20.1284 8.8266 21.1047C7.85029 22.081 6.26738 22.081 5.29107 21.1047C4.31476 20.1284 4.31476 18.5455 5.29107 17.5691C6.26738 16.5928 7.85029 16.5928 8.8266 17.5691",
    stroke: "#3E4145",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8266 2.8952C9.80291 3.87151 9.80291 5.45442 8.8266 6.43073C7.85029 7.40704 6.26738 7.40704 5.29107 6.43073C4.31476 5.45442 4.31476 3.87151 5.29107 2.8952C6.26738 1.91889 7.85029 1.91889 8.8266 2.8952",
    stroke: "#3E4145",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user_profile.1c8877551672bf07fe5704543df0b469.svg";
export { ForwardRef as ReactComponent };